export class BaseLayerControlManager {
    constructor(element, map, options) {
        this._layerColors = {};
        this._layerColorsInitialized = false;
        this._active = false;
        this._map = map;
        this._element = element;
        this._imagerySourceName = options.source;
        this._imageryImage = options.images.imagery;
        this._mapImage = options.images.map;
        this.keepOriginal = options.keepOriginal ?? [];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onAdd(_) {
        return this._element;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
    onRemove(_) {
    }
    activateImagery() {
        this._configure();
        // make fills visible.
        this.setFillVisibility(false);
        this.setRoadColor(false);
        this.setLabels(false);
        // show imagery.
        if (this._imageryLayer != null) {
            this._map.setLayoutProperty(this._imageryLayer.id, "visibility", "visible");
        }
        // hide background.
        if (this._backgroundLayer != null) {
            this._map.setLayoutProperty(this._backgroundLayer.id, "visibility", "none");
        }
        if (this.toggleEvent)
            this.toggleEvent(true);
        this._active = true;
    }
    deActivateImagery() {
        this._configure();
        // make fills visible.
        this.setFillVisibility(true);
        this.setRoadColor(true);
        this.setLabels(true);
        // show background.
        if (this._backgroundLayer != null) {
            this._map.setLayoutProperty(this._backgroundLayer.id, "visibility", "visible");
        }
        // hide imagery.
        if (this._imageryLayer != null) {
            this._map.setLayoutProperty(this._imageryLayer.id, "visibility", "none");
        }
        if (this.toggleEvent)
            this.toggleEvent(false);
        this._active = false;
    }
    setLabels(visible) {
        const style = this._map.getStyle();
        for (let l = 0; l < style.layers.length; l++) {
            const layer = style.layers[l];
            if (layer.type === "symbol" &&
                (layer["source-layer"] === "transportation_name" ||
                    layer["source-layer"] === "place")) {
                if (!layer.layout) {
                    layer.layout = {};
                }
                if (visible) {
                    this._map.setPaintProperty(layer.id, "text-color", "#000");
                    this._map.setPaintProperty(layer.id, "text-halo-color", "hsl(0, 0%, 100%)");
                }
                else {
                    this._map.setPaintProperty(layer.id, "text-color", "#fff");
                    this._map.setPaintProperty(layer.id, "text-halo-color", "rgba(0,0,0,0.4)");
                }
            }
        }
    }
    setRoadColor(visible) {
        const style = this._map.getStyle();
        for (let l = 0; l < style.layers.length; l++) {
            const layer = style.layers[l];
            if (layer.type === "line" &&
                layer["source-layer"] === "transportation") {
                if (!layer.layout) {
                    layer.layout = {};
                }
                if (this.keepOriginal.indexOf(layer.id) !== -1)
                    continue;
                if (visible) {
                    this._map.setPaintProperty(layer.id, "line-color", this._layerColors[layer.id]);
                }
                else {
                    this._map.setPaintProperty(layer.id, "line-color", "#000");
                }
            }
        }
    }
    setFillVisibility(visible) {
        const style = this._map.getStyle();
        for (let l = 0; l < style.layers.length; l++) {
            const layer = style.layers[l];
            if (layer.type === "fill") {
                if (!layer.layout) {
                    layer.layout = {};
                }
                if (visible) {
                    this._map.setLayoutProperty(layer.id, "visibility", "visible");
                }
                else {
                    this._map.setLayoutProperty(layer.id, "visibility", "none");
                }
            }
        }
    }
    _configure() {
        // make sure imagery source is there.
        if (this._imagerySource == null) {
            this._imagerySource = this._map.getSource(this._imagerySourceName);
            if (this._imagerySource == null) {
                return;
            }
        }
        // make sure imagery layer is there.
        if (this._imageryLayer == null) {
            this._imageryLayer = this._map.getLayer("background-imagery");
            if (this._imageryLayer == null) {
                this._map.addLayer({
                    "id": "background-imagery",
                    "type": "raster",
                    "source": this._imagerySourceName,
                    "minzoom": 0,
                    "maxzoom": 20,
                    "layout": {
                        "visibility": "none"
                    }
                }, "background");
                this._imageryLayer = this._map.getLayer("background-imagery");
            }
        }
        // make sure the background layer is found.
        const style = this._map.getStyle();
        for (let l = 0; l < style.layers.length; l++) {
            const layer = style.layers[l];
            if (layer.id === "background-imagery")
                continue;
            if (layer.type === "background") {
                this._backgroundLayer = layer;
            }
            if (!this._layerColorsInitialized) {
                if (layer.type === "line" &&
                    layer["source-layer"] === "transportation") {
                    this._layerColors[layer.id] = this._map.getPaintProperty(layer.id, "line-color");
                }
            }
        }
        this._layerColorsInitialized = true;
    }
}
